import React, { useState } from "react";
import "./ContactForm.css";
import emailjs from "emailjs-com";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    user_name: "",
    user_mobile: "",
    user_email: "",
    user_time: "",
  });

  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: "",
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.user_name.trim()) {
      newErrors.user_name = "Name is required";
    } else if (formData.user_name.trim().length < 2) {
      newErrors.user_name = "Name must be at least 2 characters";
    }

    if (!formData.user_mobile.trim()) {
      newErrors.user_mobile = "Phone number is required";
    } else if (!/^\+?[\d\s\-()]{10,}$/.test(formData.user_mobile.trim())) {
      newErrors.user_mobile = "Please enter a valid phone number";
    }

    if (
      formData.user_email.trim() &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.user_email.trim())
    ) {
      newErrors.user_email = "Please enter a valid email address";
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);

    emailjs
      .sendForm(
        "service_49s4y4w",
        "template_nzcvrfh",
        e.target,
        "uI9PkZF430tWUkr1G",
      )
      .then(
        (result) => {
          console.log("Email sent:", result.text);
          setShowModal(true);
          setErrors({});
          setFormData({
            user_name: "",
            user_mobile: "",
            user_email: "",
            user_time: "",
          });
        },
        (error) => {
          console.log("Error:", error.text);
          setErrors({ submit: "Failed to send message. Please try again." });
        },
      )
      .finally(() => {
        setLoading(false);
      });
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div className="contact-form-container" id="contact">
      <div className="contact-form-wrapper">
        <div className="form-header">
          <h2>Get In Touch</h2>
          <p>Fill out the form below and we'll get back to you shortly.</p>
        </div>

        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="user_name">Full Name *</label>
            <input
              type="text"
              id="user_name"
              name="user_name"
              value={formData.user_name}
              onChange={handleInputChange}
              className={errors.user_name ? "error" : ""}
              placeholder="Enter your full name"
            />
            {errors.user_name && (
              <span className="error-message">{errors.user_name}</span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="user_mobile">Phone Number *</label>
            <input
              type="tel"
              id="user_mobile"
              name="user_mobile"
              value={formData.user_mobile}
              onChange={handleInputChange}
              className={errors.user_mobile ? "error" : ""}
              placeholder="Enter your phone number"
            />
            {errors.user_mobile && (
              <span className="error-message">{errors.user_mobile}</span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="user_email">Email Address (Optional)</label>
            <input
              type="email"
              id="user_email"
              name="user_email"
              value={formData.user_email}
              onChange={handleInputChange}
              className={errors.user_email ? "error" : ""}
              placeholder="Enter your email address"
            />
            {errors.user_email && (
              <span className="error-message">{errors.user_email}</span>
            )}
          </div>

          {errors.submit && (
            <span className="error-message">{errors.submit}</span>
          )}

          <input
            type="hidden"
            name="user_time"
            value={new Date().toLocaleString("en-IN", {
              dateStyle: "full",
              timeStyle: "medium",
              timeZone: "Asia/Kolkata",
            })}
          />

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Sending..." : "Submit"}
          </button>
        </form>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Thank You! {formData.user_name}</h3>
              <button className="modal-close" onClick={closeModal}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="success-icon">✓</div>
              <p className="success-message">
                Your form has been submitted successfully!
              </p>
              <p className="contact-message">
                Geetha will reach you in a short time.
              </p>
            </div>
            <div className="modal-footer">
              <button className="modal-btn" onClick={closeModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactForm;
